"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockLayout = exports.BlockLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var content_node_1 = require("./content-node");
var grid_1 = require("../elements/grid");
var entity_link_value_1 = require("./entity-link-value");
var lodash_1 = require("lodash");
var sprintf_js_1 = require("sprintf-js");
var content_title_1 = require("../elements/content-title");
exports.BlockLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    .shp-cell-label {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    ", ";\n    .shp-cell-label {\n      color: ", ";\n    }\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.FILL('text'), theme_1.theme.COLOR('text'))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.H_DOT_BG_END('line', 1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: -", ";\n    padding-top: ", ";\n\n  "], ["\n    margin-top: ", ";\n    margin-bottom: -", ";\n    padding-top: ", ";\n\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1))
});
var LinkedValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkedLinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3))
});
var SubtitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    font-size: ", ";\n  "], ["\n    margin-bottom: ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(15))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n\n  "], ["\n    ", ";\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n\n  "])), theme_1.theme.H_DOT_BG_END('line', 1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Header: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Layout: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  LinkedValue: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LinkedValueStyles),
  LinkedLinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LinkedLinkValueStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Body: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Subtitle: styled_components_1.default.h2(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  // Intro: styled(ContentNode)`${IntroStyles}`,
  // Outro: styled(ContentNode)`${OutroStyles}`,
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
var BlockLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    formatName = props.formatName,
    number = props.number;
  var content = entity.content,
    title = entity.title,
    subtitle = entity.subtitle,
    image = entity.image,
    color = entity.color,
    backgroundColor = entity.backgroundColor,
    page = entity.page,
    _a = entity.links,
    links = _a === void 0 ? [] : _a,
    icon = entity.icon,
    layout = entity.layout;
  var gridItems = (0, lodash_1.filter)(__spreadArray(__spreadArray([image && react_1.default.createElement(My.LinkedValue, {
    showMenu: true,
    label: "Image",
    entity: image
  }), icon && react_1.default.createElement(My.LinkedValue, {
    showMenu: true,
    entity: icon
  }), color && react_1.default.createElement(My.LinkedValue, {
    showMenu: true,
    entity: color
  }), page && react_1.default.createElement(My.LinkedLinkValue, {
    showMenu: true,
    entity: page
  })], __read(links && links.map(function (link) {
    return react_1.default.createElement(My.LinkedValue, {
      key: link.id,
      showMenu: true,
      entity: link
    });
  }) || []), false), [backgroundColor && react_1.default.createElement(My.LinkedValue, {
    showMenu: true,
    label: "Background {{COLOR}}",
    entity: backgroundColor
  })], false));
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Header, null, react_1.default.createElement(My.Value, {
    imageSpacing: 2,
    variant: "card",
    imageSize: 20,
    showMenu: true,
    name: "",
    entity: entity,
    label: number !== undefined ? (0, sprintf_js_1.sprintf)("{{BLOCK}} #%d", number) : "{{BLOCK}}"
  })), layout && react_1.default.createElement(My.Layout, {
    entity: layout
  }), react_1.default.createElement(My.Body, null, title && react_1.default.createElement(My.Title, null, title), subtitle && react_1.default.createElement(My.Subtitle, null, subtitle), content && react_1.default.createElement(My.Content, {
    entity: content
  }), !!gridItems.length && react_1.default.createElement(My.Grid, {
    spacing: 4,
    columns: 1,
    items: gridItems
  })));
};
exports.BlockLayout = BlockLayout;
exports.BlockLayout.defaultProps = exports.BlockLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;